import { useContext, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { LocalShipping, MoreHoriz, VpnKey } from '@mui/icons-material';
import { Box, FormControlLabel, Grid, Switch, Tab, Tabs } from '@mui/material';
import { IntegracaoContext } from 'contexts/IntegracaoContext';
import { DropsContext } from 'contexts/DropsContext';
import { AuthContext } from 'contexts/AuthContext';
import Container from 'components/Container';
import Dropdown from 'components/Dropdown';
import Button from 'components/Button';
import Header from 'components/Header';
import Input from 'components/Input';
import styles from './styles';

const IncubadoraR = ({ logo, loading, integracao }) => {
  const [tab, setTab] = useState(0);
  const access_data = integracao?.access_data;
  const defaultValues = {
    id: integracao?.id,
    //ACESSO
    nome_integracao: access_data?.nome_integracao || '',
    key: access_data?.key || '',
    //EXPEDICAO
    enviar_armazenagem: access_data?.enviar_armazenagem || null,
    local_envia: access_data?.local_envia || null,
    //OUTROS
    users_id: access_data?.users_id || null,
  };
  const { user } = useContext(AuthContext);
  const { drops } = useContext(DropsContext);
  const { postIncubadoraE } = useContext(IntegracaoContext);
  const { control, handleSubmit, setValue } = useForm({ defaultValues });

  const onGenerateKey = () => {
    const str = `${user?.documento || ''}${user?.usuario_id}`;
    setValue('key', str);
  };

  const handleSave = (data) => {
    postIncubadoraE({ data });
  };

  return (
    <Container>
      <Header titulo="Configurações" />
      <Grid container spacing={5}>
        <Grid item xs={12}>
          <Box sx={styles?.header}>
            <Box
              src={logo}
              component="img"
              sx={styles?.img}
              alt={integracao?.api}
            />
            <Tabs value={tab} onChange={(_, v) => setTab(v)}>
              <Tab
                value={0}
                icon={<VpnKey />}
                iconPosition="start"
                label="Acesso"
              />
              <Tab
                value={1}
                icon={<LocalShipping />}
                iconPosition="start"
                label="Expedição/Recebimento"
              />
              <Tab
                value={2}
                icon={<MoreHoriz />}
                iconPosition="start"
                label="Outros"
              />
            </Tabs>
          </Box>
        </Grid>
        <Grid item xs={12} display={tab === 0 ? 'block' : 'none'}>
          <Grid container spacing={2}>
            <Grid item xs={12} display="flex" alignItems="center" gap={2}>
              <Box flex={1}>
                <Input
                  name="key"
                  control={control}
                  label="Chave da Integração"
                />
              </Box>
              <Button
                onClick={onGenerateKey}
                disabled={Boolean(access_data?.key)}
                startIcon={<VpnKey fontSize="medium" />}
              >
                Gerar Key
              </Button>
            </Grid>
            <Grid item xs={12}>
              <Input
                control={control}
                name="nome_integracao"
                label="Nome da Integração"
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} display={tab === 1 ? 'block' : 'none'}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Controller
                name="enviar_armazenagem"
                control={control}
                render={({ field }) => (
                  <FormControlLabel
                    label="Enviar para o Receptor ao Indicar Armazenagem"
                    control={
                      <Switch
                        {...field}
                        checked={field?.value}
                        onChange={(e) => field?.onChange(e?.target?.checked)}
                      />
                    }
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Dropdown
                control={control}
                name="local_envia"
                options={drops?.LocalEstoque}
                label="Local de Estoque para Envio ao Receptor"
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} display={tab === 2 ? 'block' : 'none'}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Dropdown
                name="users_id"
                control={control}
                options={drops?.Users}
                label="Usuário Responsável pelo Histórico de Expedição/Recebimento e para Receber Notificações"
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Box sx={styles?.bottom}>
        <Button
          color="primary"
          loading={loading}
          variant="contained"
          onClick={handleSubmit(handleSave)}
        >
          Salvar
        </Button>
      </Box>
    </Container>
  );
};

export default IncubadoraR;
